(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.rcdsEnvir = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var getRcdsEnvironment = exports.getRcdsEnvironment = function getRcdsEnvironment() {
    var wv_rcds_url = void 0;
    if (window.wv_rcds && window.wv_rcds.sponsorshipEnv && window.wv_rcds.sponsorshipEnv.url && window.wv_rcds.sponsorshipEnv.token) {
      //check for failover window object
      if (window.WVUS_SPONSORSHIP_FAILOVER) {
        switch (window.WVUS_SPONSORSHIP_FAILOVER.failover_mode) {
          case "1":
            //failoverURL
            var FAILOVER_OBJ = window.WVUS_SPONSORSHIP_FAILOVER;
            wv_rcds_url = {
              url: FAILOVER_OBJ.base_url,
              token: FAILOVER_OBJ.failover_token,
              sponsorshipAPIurl: ""
            };
            break;
          case "0":
            //use the non fail over URL
            wv_rcds_url = window.wv_rcds.sponsorshipEnv;
            break;
          default:
            //use the non fail over URL
            wv_rcds_url = window.wv_rcds.sponsorshipEnv;
            break;
        }
      }
      //if no failover variable exists, assume normal rcds env.
      else {
          wv_rcds_url = window.wv_rcds.sponsorshipEnv;
        }
    }
    //use local default urls
    else {
        wv_rcds_url = {
          url: "https://wv-rcds-uat-api.azure-api.net/v3",
          token: "a7cb8b5004ef430ba2af2fd813b78270",
          sponsorshipAPIurl: "http://www.worldvision.org/wp-json/sponsorship/v1"
        };
      }
    return wv_rcds_url;
  };

  exports.default = getRcdsEnvironment;
});